import React from 'react';
import { isEmpty } from 'lodash';
import { connect } from 'react-redux';
import RowClick from '../../../common/RowClick';
import Const from './Const';
import {
  REDUCER_NAME,
  intervalFetchRanking,
  loadMoreRanking,
  defaultSortState,
} from '../reducer';
import { compose } from 'redux';
import STTable from './../../../common/mixTable/STTable';
import { I18n } from 'react-redux-i18n';
import { changeSortState } from '../reducer';

class FiinTradeRankingTable extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      page: 1,
      pageSize: Const.maxRowData,
      rankingId: 1,
      isHover: false,
    };
    this.state = this.initialState;
  }

  componentDidMount() {
    const { intervalFetchRanking, industryId } = this.props;
    intervalFetchRanking(industryId);
  }

  componentDidUpdate(prevProps, prevState) {
    const { intervalFetchRanking, industryId, sortState } = this.props;
    const isSortStateChanged =
      sortState !== prevProps.sortState &&
      Const.fetchDataSortKeys.includes(Object.keys(sortState)[0]);
    if (
      prevProps.i18n.locale !== this.props.i18n.locale ||
      isSortStateChanged
    ) {
      intervalFetchRanking(industryId);
    }
  }

  getDataFromRedux = state => {
    return state[REDUCER_NAME].listRankingByTicker;
  };

  handleScroll = e => {
    const { page } = this.state;
    const { totalPage, ids } = this.props;
    if (page === totalPage) return;
    if (ids.length < Const.maxRowData) return;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (bottom) {
      this.loadMoreActive();
    }
  };

  loadMoreActive = () => {
    const {
      loadMoreRanking,
      listRankingByTicker,
      totalPage,
      listRankingLoadMore,
      industryId,
      isLoading,
      rankingId,
      page,
    } = this.props;
    if (page === totalPage || isLoading) return;
    let pageCurrent = parseInt(page);
    this.setState(() => {
      loadMoreRanking({
        Page:
          isEmpty(listRankingLoadMore) &&
          !isEmpty(listRankingByTicker) &&
          pageCurrent > 1
            ? pageCurrent
            : pageCurrent + 1,
        Code: industryId,
        rankingId,
      });
    });
  };

  onSort = sortState => {
    const { changeSortState } = this.props;
    if (!Object.keys(sortState).length) {
      changeSortState(defaultSortState);
      return;
    }
    changeSortState(sortState);
  };

  renderTable() {
    const {
      isLoading,
      ids,
      changeIdHover,
      organCodeHover,
      listConfigTable,
    } = this.props;
    let idHover = organCodeHover;
    if (!ids.includes(organCodeHover) && organCodeHover !== '') {
      idHover = '';
    }
    return (
      <RowClick>
        {onRowClick => (
          <STTable
            onSort={this.onSort}
            onRowClick={onRowClick}
            ids={ids}
            isLoading={isLoading}
            getDataFromRedux={this.getDataFromRedux}
            schemaKey={'stRanking.fiinTradeRankingsHeader'}
            listColumn={listConfigTable}
            isHeaderTable={true}
            titleHeaderTable={I18n.t('stRanking.titleTableRanking')}
            colorLeft="#2f9db4"
            colorRight="#76dbc7"
            isHighlight={true}
            idHover={idHover}
            changeIdHover={changeIdHover}
            handleScroll={this.handleScroll}
          />
        )}
      </RowClick>
    );
  }

  render() {
    return this.renderTable();
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    ids: state[REDUCER_NAME].listTickerRanking,
    listRankingByTicker: state[REDUCER_NAME].listRankingByTicker,
    listRankingLoadMore: state[REDUCER_NAME].listRankingLoadMore,
    industryId: state[REDUCER_NAME].industryId,
    organCodeHover: state[REDUCER_NAME].organCodeHover,
    organCode: state[REDUCER_NAME].organCode,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
    firstPage: state[REDUCER_NAME].firstPage,
    page: state[REDUCER_NAME].page,
    sortState: state[REDUCER_NAME].sortState,
  };
};

const mapDispatchToProps = {
  loadMoreRanking,
  intervalFetchRanking,
  changeSortState,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);

export default enhance(FiinTradeRankingTable);
